<template lang="pug">
v-container.shopcms-container.pt-0.px-0(fluid)
    v-row
      //- Banner
      v-col(cols="12")
        h2.mb-5 Banner
        v-app-bar(
          dark
          shrink-on-scroll
          prominent
          height="200"
          :src="cover"
          fade-img-on-scroll
          scroll-target="#scrolling-techniques-3"
          elevation="10"
        )
          input.d-none(ref="file" type="file" @change="handleImageUpload" accept='image/*')
          v-btn.edit-btn(text small color="success" @click="$refs.file.click()")
            v-icon mdi-pencil
          //- template(v-slot:img="{ props }")
            v-img(v-bind="props")
      //- Colors Primary
      v-col(cols="12" sm="6" md="12" lg="6")
          v-row.mb-5
              h2.mr-2 Color principal
              v-tooltip(top)
                  template(v-slot:activator='{ attrs, on }')
                      v-icon(v-bind='attrs' v-on='on' size="20") mdi-information
                  span El color principal es utilizado para categorias, botones y características.
          v-color-picker(elevation="5" mode="hexa" v-model="colors.primary")
      //- Colors Secondary
      v-col(cols="12" sm="6" md="12" lg="6")
          v-row.mb-5
              h2.mr-2 Color secundario
              v-tooltip(top)
                  template(v-slot:activator='{ attrs, on }')
                      v-icon(v-bind='attrs' v-on='on' size="20") mdi-information
                  span El color secundario es utilizado para los títulos y precios de productos.
          v-color-picker(elevation="5" mode="hexa" v-model="colors.secondary")
</template>

<script>
  export default {
    components: {},
    props: {
      colors: {
        type: Object,
        default: () => {
          return {
            primary: '#008e95FF',
            secondary: '#008e95FF',
          }
        },
      },
      banner: {
        type: String,
        default: () => {
          return ''
        },
      },
    },
    data () {
      return {
        primary: '#008e95FF',
        secondary: '#008e95FF',
        cover: 'https://via.placeholder.com/150',
      }
    },
    mounted () {
      const vm = this
      if (vm.banner && vm.banner !== '') vm.cover = vm.banner
      if (vm.colors) {
        if (vm.colors.primary) vm.primary = vm.colors.primary
        if (vm.colors.secondary) vm.secondary = vm.colors.secondary
      }
    },
    methods: {
      handleImageUpload (event) {
        const vm = this
        const imageFile = event.target.files[0]
        vm.$emit('uploadBanner', imageFile)
        vm.cover = URL.createObjectURL(imageFile)
      },
      updatePrimary (event) {
        this.$emit('updateColor', { primary: event })
      },
      updateSecondary (event) {
        this.$emit('updateColor', { secondary: event })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .edit-btn{
    position: absolute;
    z-index: 9999;
    right: 20px;
    top: 20px;
  }
</style>
